<template>
    <div class="contain">
      <div class="topTitle flex">
        <span class="preview"></span>
        <el-select
          v-model="region"
          placeholder="请选择商户"
          @change="MerchSelete"
          style="width: 200px"
        >
          <el-option v-for="(item,index) in seleteAppList" :key="index" :label="item.nickName" :value="index"></el-option>
        </el-select>
      </div>
      <div class="from">
           <div class="visit flex">
                <div class="flex">
                   <div class="pressActive flex flex-center item-center" :class="[item.checked ?'activers':'']" @click="seletesTimes(index)" v-for="(item,index) in seleButton" :key="index">
                     <span class="copywriting" :class="[item.checked ?'active':'']">{{item.name}}</span>
                  </div>
                    <!-- <el-button type="primary">新增用户</el-button>
                    <el-button>活跃用户</el-button> -->
                </div>
                <div class="flex">
                    <div class="flex" style="margin-right: 20px">
                         <div class="pressActive flex flex-center item-center" :class="[item.checked ?'activers':'']" @click="seletButton(index)" v-for="(item,index) in seleTimes" :key="index">
                      <span class="copywriting" :class="[item.checked ?'active':'']">{{item.name}}</span>
                  </div>
                    </div>
                    <el-date-picker
                      v-model="value1"
                      @change="change"
                      type="daterange"
                      value-format="yyyy-MM-dd"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
                  </el-date-picker>
                </div>
           </div>
            <div class="system flex">
        <div class="cylinder flex">
          <div class="ringColumn flex">
            <div class="sysTime flex flex-1 flex-center item-center">
              <div class="flex flex-center terminal">
                <span class="written">终端系统分析</span>
              </div>
              <ve-ring
                :data="retained"
                :legend-visible="false"
                :settings="ringextend"
                :colors="ringcolor"
                :title="title"
                height="350px"
                width="280px"
                class="huan"
              />
              <div class="flex iconList">
                <div class="flex item-center modelOne">
                  <div class="android"></div>
                  <span class="tips">Android</span>
                </div>
                <div class="flex item-center modelTwo">
                  <div class="ios"></div>
                  <span class="tips">IOS</span>
                </div>
                <div class="flex item-center modelThree">
                  <div class="other"></div>
                  <span class="tips">其他</span>
                </div>
              </div>
            </div>
            <div class="sysRatio flex-1">
              <div class="flex terminal">
                <span class="written">终端系统分析</span>
              </div>
              <div class="showPortion flex">
                <div class="android flex item-center">
                  <span>男</span>
                  <el-progress
                    :text-inside="true"
                    :stroke-width="30"
                    :format="format"
                    :percentage="malePortion"
                    color="#5ACDB7"
                    style="width: 740px; margin-left: 17px"
                  ></el-progress>
                </div>
                <div class="android flex item-center">
                  <span>女</span>
                  <el-progress
                    :text-inside="true"
                    :stroke-width="30"
                    :format="format"
                    :percentage="femalePortion"
                    color="#6648FF"
                    style="width: 740px; margin-left: 17px"
                  ></el-progress>
                </div>
                <div class="android flex item-center">
                  <span>未知</span>
                  <el-progress
                    v-if="unPortion >=0"
                    :text-inside="true"
                    :stroke-width="30"
                    :format="format"
                    :percentage="unPortion"
                    color="#E78B00"
                    style="width: 740px; margin-left: 17px"
                  ></el-progress>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div class="mapVisual flex" style="height: 700px;overflow: scroll;background: #FFFFFF;padding: 20px;">
          <visua-liza :allCity='cityList' ></visua-liza>
          <div style="margin-left:300px">
              <el-table
              :data="tableData"
              style="width: 100%"
              height="600"
              :default-sort = "{prop: 'date', order: 'descending'}"
              >
              <el-table-column label="省份"  prop="eventName" width="180"></el-table-column>
              <el-table-column
                prop="eventValue"
                label="访问人数"
                sortable
                width="180">
              </el-table-column>

            </el-table>
          </div>
      </div>
      <div class="mapVisual flex" style="height: 700px;overflow: scroll;background: #FFFFFF;padding: 20px;" >
        <city-visua-liza :cityAllList='cityAllList'></city-visua-liza>
        <div style="margin-left:300px">
          <el-table
              :data="cityTableData"
              style="width: 100%"
              height="600"
              :default-sort = "{prop: 'date', order: 'descending'}"
          >
            <el-table-column label="城市"  prop="eventName" width="180"></el-table-column>
            <el-table-column
                prop="eventValue"
                label="访问人数"
                sortable
                width="180">
            </el-table-column>

          </el-table>
        </div>
      </div>
    </div>

</template>

<script>
import VeRing from "v-charts/lib/ring.common";
import visuaLiza from './moults/visualization'
import cityVisuaLiza from './moults/cityVisualization'
import cityVisuaLizaTwo from './moults/cityVisualization'
export default {
  data() {
    // 环形图
    this.title = {
      text: "30%",
      x: "center",
      y: "center",
      itemGap: 20,
      textStyle: {
        color: "#ffffff",
        fontFamily: "微软雅黑",
        fontSize: 20,
        fontWeight: "bolder",
      },
    };
    (this.ringextend = {
      radius: ["50%", "100%"],
      label: {
        //去除饼图的指示折线label
        normal: {
          show: false,
          position: "inside",
        },
      },
      labelLine: {
        normal: {
          label: {
            show: true,
            formatter: "({d}%)",
          },
          labelLine: { show: true },
        },
      },
      // 全局字体样式
      textStyle: {
        color: "#ffffff",
      },
    }),
      // 环形图颜色
      (this.ringcolor = ["#5ACDB7", "#6648FF", "#E78B00"]);
    return {
      region: "",
      initiali:{},
      seleButton:[
        {
          name: '新增用户',
          checked: true
        },
        {
          name: '活跃用户',
          checked: false
        }
      ],
      seleTimes: [
          {
              name: '昨天',
              checked: true
          },
          {
              name: '过去7天',
              checked: false
          },
            {
              name: '过去30天',
              checked: false
          }
      ],
      sixList: [

      ],
      type: 'new',
      seleteAppList: [],
      cityList: [],
      cityAllList:[],
      progressNum: 30,
      timesList: [],
      malePortion: 0,  // 男占比
      femalePortion: 0, // 女占比
      unPortion: 0, // 未知占比
      equipment: [],
      tableData: [],
      cityTableData: [],
      yesterday: '',
      numberList: [],
      week: '',
      today: '',
      month: '',
      value1: '',
      // 环形图一 数据
      retained: {
        columns: ["型号", "人数"],
        labelLine: {
          normal: {
            show: false,
          },
        },
        rows: [
          { 型号: "安卓", 人数: 30 },
          { 型号: "苹果", 人数: 40 },
          { 型号: "其他", 人数: 30 },
        ],
      },
    };
  },
  components: {
    "ve-ring": VeRing,
     visuaLiza,
    cityVisuaLiza,
    cityVisuaLizaTwo
  },
  created() {
   let curDate = new Date();
      var nowDate = curDate.getTime();
      var preDate = new Date(curDate.getTime() - 24*60*60*1000); //前一天
      var week = new Date(curDate.getTime() - 24*60*60*1000*7); // 过去7天
      var month = new Date(curDate.getTime() - 24*60*60*1000*30); // 过去30天
      this.today = this.formatDateTime(curDate)
      this.yesterday =this.formatDateTime(preDate)
      this.week = this.formatDateTime(week)
      this.month =  this.formatDateTime(month)
    this.getSeleteWechat()
    this.value1 = [this.yesterday,this.yesterday]
  },
  methods: {
    format(percentage) {
      let str = percentage === 100 ? "满" : percentage.toFixed(2)+'%';
      if (percentage === 0) {
        str = percentage.toFixed(1)+'%'
      }
      return str;
    },
    change(e){
      this.timesList = e
       if(e){ // 表示用户已经选择时间
            this.seleTimes.forEach(item => {
              item.checked = false
            })
          }
        this.get_init(e[0],e[1])
    },
    seletButton(e){
      let index =e
       this.seleTimes.forEach(item => {
              item.checked = false
          })
        this.seleTimes[index].checked = !this.seleTimes[index].checked
        if(index === 0){
          this.value1 = [this.yesterday,this.yesterday]
          this.get_init(this.yesterday,this.yesterday)
        }else if(index === 1){
          this.value1 = [this.week,this.yesterday]
           this.get_init(this.week,this.yesterday)
        }else if(index === 2){
            this.value1 = [this.month,this.yesterday]
            this.get_init(this.month,this.yesterday)
        }
    },
    formatDateTime (date) {
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h=h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        minute = minute < 10 ? ('0' + minute) : minute;
        var second=date.getSeconds();
        second=second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d;
    },
    seletesTimes(index){
       this.seleButton.forEach(item => {
              item.checked = false
          })
        this.seleButton[index].checked = !this.seleButton[index].checked
        if(index === 0){
           this.type = 'new'
        }else {
          this.type = 'uv'
        }

        // 判断当前的时间
       var i =this.seleTimes.findIndex(item => item.checked)
       if(i !== -1){
          if(i === 0) { // 昨天
             this.get_init(this.yesterday,this.yesterday)
          }else if(i === 1) { // 一周
              this.get_init(this.week,this.yesterday)
          }else if(i === 2){ // 一月
              this.get_init(this.month,this.yesterday)
          }
       }else {
           this.get_init(this.timesList[0],this.timesList[1])
       }

    },
    async get_init(star,end){
      const { result } = await this.$store.dispatch("queryAllWechatFlow",{
        busType: this.initiali.miniProgramType,
        visitType: this.type,
        queryEndDate: end,
        queryStartDate: star,
        storeCode: this.initiali.storeCode
      });
      this.equipment = result.platformList
      this.numberList = result.genderList
      this.sixList = []
      let allTotal = 0
      let list = []
      this.equipment.forEach(item => {
           if(item.eventName === 'iPhone'){
              list.push({
                 型号: '苹果',
                 人数: item.eventValue
              })
           }else if(item.eventName === 'Android'){
             list.push({
                 型号: '安卓',
                 人数: item.eventValue
              })
           }else if(item.eventName === '未知'){
             list.push({
                 型号: '其他',
                 人数: item.eventValue
              })
           }
      })
      this.retained.rows = list
      this.numberList.forEach(item => {
         allTotal += parseInt(item.eventValue)
      })
      let male = this.numberList.find(item => {
        return item.eventName === '男'
      })
      let female = this.numberList.find(item => {
        return item.eventName === '女'
      })
      this.sixList.push(female)
      let unk = this.numberList.find(item => {
        return item.eventName === '未知'
      })
      if(unk !== undefined){

      }else {
        unk={
           eventName: '未知',
           eventValue: 0
        }
      }
      this.tableData = result.provinceList
       this.$nextTick(() => {
    this.cityList = result.provinceList
  });

      this.cityTableData = result.cityList;
      this.$nextTick(() => {
        this.cityAllList = result.cityList;
      });

      console.log("this.cityList = ",this.cityList);
      if (allTotal != 0) {
        this.malePortion = parseInt(male.eventValue) / allTotal *100
        this.femalePortion = parseInt(female.eventValue) /allTotal * 100
        this.unPortion = parseInt(unk.eventValue) /allTotal * 100
      }
    },
    async getSeleteWechat(){
        const { result } = await this.$store.dispatch("queryWechatSelete",{});
        this.seleteAppList = result
        this.initiali = result[0]
        this.region = this.initiali.nickName
        this.get_init(this.yesterday,this.yesterday)
    },
    MerchSelete(e){
      let index = e
      this.initiali = this.seleteAppList[index]
      this.seleButton.forEach(item => {
        item.checked = false
      })
      this.seleButton[0].checked = true
       this.seleTimes.forEach(item => {
        item.checked = false
      })
      this.seleTimes[0].checked = true
      this.type = 'new'
      this.get_init(this.yesterday,this.yesterday)
    }
  },
};
</script>

<style lang="scss" scoped>
.pressActive{
    width: 90px;
    height: 40px;
    background: #FFFFFF;
    border: 1px solid #DCDFE6;
    cursor: pointer;
    .copywriting{
        color: #000;
        font-size: 14px;
        &.active{

            color: #FFFFFF;
        }
    }
    &.activers{
        background: #E50163;
    }
}

.contain {
  flex-direction: column;
  .topTitle {
   background: #fff;
    margin-bottom: 10px;
    padding: 20px;
    align-items: center;
    justify-content: flex-end;
    // align-items: center;
    // border-bottom: 1px solid #e5e9f2;
    .preview {
      color: #222222;
      font-weight: 500;
      font-size: 26;
    }
  }
  .from{
    background: #FFFFFF;
    padding: 20px;
    margin-bottom: 10px;
  }

  .visit {
    margin-top: 20px;
    justify-content: space-between;
  }
  .translate {
    // justify-content: space-between;
    align-items: center;
    padding: 10px;
    background: #f8f8f8;
    margin-top: 20px;
    .title {
      .pattern {
        display: block;
        width: 3px;
        height: 16px;
        background: #2a75ed;
        margin-right: 8px;
      }
    }
  }
  .system {
    margin-top: 30px;
    // justify-content: space-around;
    .cylinder {
      width: 100%;
      flex-direction: column;
      justify-content: center;
    }
    .ringColumn {
      .terminal {
        align-self: flex-start;
        .written {
          color: #999999;
          font-size: 16px;
        }
      }
      .sysTime {
        flex-direction: column;
        .iconList {
          margin-top: 10px;
          .modelOne {
            justify-content: center;
            .android {
              width: 10px;
              height: 10px;
              border-radius: 100%;
              background: #5acdb7;
              margin-bottom: 10px;
            }
            .tips {
              font-size: 14px;
              color: #000000;
              font-weight: 500;
              margin-left: 10px;
              margin-top: -13px;
            }
          }
          .modelTwo {
            margin-left: 36px;
            .ios {
              width: 10px;
              height: 10px;
              border-radius: 100%;
              background: #6648ff;
              margin-bottom: 10px;
            }
            .tips {
              font-size: 14px;
              color: #000000;
              font-weight: 500;
              margin-left: 10px;
              margin-top: -13px;
            }
          }
          .modelThree {
            margin-left: 36px;
            .other {
              width: 10px;
              height: 10px;
              border-radius: 100%;
              background: #e78b00;
              margin-bottom: 10px;
            }
            .tips {
              font-size: 14px;
              color: #000000;
              font-weight: 500;
              margin-left: 10px;
              margin-top: -13px;
            }
          }
        }
      }
      .sysRatio {
        align-self: flex-start;
        flex-direction: column;
        .terminal {
          .written {
            color: #999999;
            font-size: 16px;
          }
        }
        .showPortion {
          margin-top: 125px;
          flex-direction: column;
          width: 820px;
          .android {
            height: 30px;
            margin-bottom: 40px;
            span {
              color: #222222;
              font-size: 14px;
              margin-right: 17px;
            }
          }
        }
      }
    }
  }
  .interval{
      margin-top: 30px;
      width: 100%;
      height: 10px;
      background: #F4F4F4;
  }
  .mapVisual{
     background: #F4F4F4;
     margin-bottom: 10px;
  }
  .unicipal{
    background: #FFFFFF;
    height: 700px;
    padding: 20px;
  }
}
</style>